import gql from 'graphql-tag';
import { SURVEY_LIST_FRAGMENT } from './q_survey';

const Q_GET_CAMPAIGNS = gql`
    query GetCampaigns($campaign_id: uuid, $org_id: uuid) {
        campaigns(
            where: { _and: [{ id: { _eq: $campaign_id } }, { org_id: { _eq: $org_id } }] },
            order_by: { id: asc }
        ) {
            id
            title
            description
            created_at
            surveys {
                id
            }
        }
    }
`;

const Q_GET_CAMPAIGN = gql`
    query GetCampaigns($campaign_id: uuid, $org_id: uuid) {
        campaigns(
            where: { _and: [{ id: { _eq: $campaign_id } }, { org_id: { _eq: $org_id } }] },
            order_by: { id: asc }
        ) {
            id
            org_id
            title
            description
            created_at
            updated_at
        }
    }
`;

const Q_GET_CAMPAIGN_AND_SURVEYS = gql`
    query GetCampaigns($campaign_id: uuid, $org_id: uuid, $author_id: uuid) {
        campaigns(where: {
            _and: [
                { id: { _eq: $campaign_id } },
                { org_id: { _eq: $org_id } }
            ]
        }) {
            id
            org_id
            title
            description
            created_at
            updated_at
            surveys(where: {author_id: {_eq: $author_id}}) {
                ${SURVEY_LIST_FRAGMENT}
            }
        }
    }
`;



export {
    Q_GET_CAMPAIGN,
    Q_GET_CAMPAIGN_AND_SURVEYS,
    Q_GET_CAMPAIGNS
}

